/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import { Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";

// Argon Dashboard 2 MUI example components
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Argon Dashboard 2 MUI base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "assets/images/bruce-mars.jpg";
import CardContent from "@mui/material/CardContent";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import { useNavigate } from "react-router-dom";
import axios from "utils/api";
import { baseURL } from "utils/api";
import { toast } from 'react-toastify';

function Header() {

    const [update, setUpdate] = useState(false);
    const [confirmUpdateOpen, setConfirmUpdateOpen] = useState(false);
    const handleUpdate = ()=>{
    setUpdate(true);
   }
    const handleCloseUpdate = ()=>{
      setUpdate(false);
   }

   const [password, setPassword] = useState(false);
  const handlePassword = () => {
    setPassword(true);
  }
  const handleClose = () => {
    setPassword(false);
  }

  //logout 
   const navigate = useNavigate();
  const handleLogout = () => {
    // 🔑 localStorage saaf karo
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("allowedPermissions");
    // agar sab saaf karna hai to: localStorage.clear();
    // // ✅ redirect to sign-in
    navigate("/authentication/sign-in");
    toast.success("Logged out successfully!");
  };

  const [userData, setUserData] = useState(null);
  // update profile
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
  });
  // handle update form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
  const savedUser = localStorage.getItem("user");
  if (savedUser) {
    const parsedUser = JSON.parse(savedUser);
    setUserData(parsedUser);
    // set formData so inputs are editable
    setFormData({
      fullName: parsedUser.fullName || "",
      email: parsedUser.email || "",
    });
  }
}, []);

   // ------------------ UPDATE PROFILE (API CALL) ------------------
  const handleSaveUpdate = (e) => {
    if (e) {
      e.preventDefault();
    }
    setConfirmUpdateOpen(false);

    axios
      .put(`${baseURL}/user/${userData._id}`, {
        fullName: formData.fullName,
        email: formData.email,
      })
      .then((res) => {
        console.log("✅ Profile updated:", res.data);
        if (res.data.success) {
          toast.success("Profile updated successfully!");

          // update localStorage + state
          const updatedUser = { ...userData, ...formData };
          localStorage.setItem("user", JSON.stringify(updatedUser));
          setUserData(updatedUser);

          setUpdate(false);
        } else {
          toast.error(res.data.message || "Failed to update profile");
        }
      })
      .catch((err) => {
        console.error("❌ Error updating profile:", err);
        toast.error("Something went wrong!");
      });
  };

  if (!userData) return null;


  // useEffect(() => {
  //   const savedUser = localStorage.getItem("user");
  //   if (savedUser) {
  //     setUserData(JSON.parse(savedUser));
  //   }
  // }, []);

  // if (!userData) return null;




  return (
    <ArgonBox position="relative">
      <DashboardNavbar absolute light />
      <ArgonBox height="220px" />
       <Card
  sx={{
    py: 4,
    px: 4,
    boxShadow: ({ boxShadows: { md } }) => md,
    borderRadius: "16px",
  }}
>
  <Grid container direction="column" spacing={4}>
    {/* Profile Section */}
    <Grid item>
      <Grid container spacing={2} alignItems="center" justifyContent="flex-start">
        <Grid item>
          <ArgonAvatar
            // src={burceMars}
            alt="profile-image"
            variant="rounded"
            size="xl"
            shadow="sm"
          />
        </Grid>
        <Grid item>
          <ArgonBox display="flex" justifyContent="space-between" alignItems="center" gap={2}>
          <ArgonBox height="100%" mt={0} lineHeight={1} textAlign="left">
            <ArgonTypography variant="h5" fontWeight="medium">
                 {userData.fullName}
            </ArgonTypography>

            <ArgonBox display="flex" flexDirection="column">
               <ArgonTypography
              textTransform="none"
              variant="button"
              color="text"
              fontWeight="medium"
            >
              {userData.email}
             </ArgonTypography>
             
             <ArgonTypography
              textTransform="none"
              variant="button"
              color="text"
              fontWeight="medium"
            >
             {userData.role}
            </ArgonTypography>
            </ArgonBox>
           

          </ArgonBox>
          <ArgonBox display="flex" alignItems="center" gap={2} mt={1}>
            <ArgonButton onClick={handleLogout} variant="contained" color="primary">Logout</ArgonButton>
          </ArgonBox>
          <ArgonBox/>
          </ArgonBox>
        </Grid>
      </Grid>
    </Grid>

    {/* User Information Form Section */}
    <Grid item xs={12} style={{ width: "100%" }}>
      <Card
        sx={{
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
          p: 4,
          background: "linear-gradient(145deg, #ffffff, #f9f9f9)",
        }}
      >
        <CardContent>
          {/* Section Title */}
          <ArgonTypography
            variant="h5"
            fontWeight="bold"
            color="dark"
            sx={{ mb: 3, textAlign: "center" }}
          >
            User Information
          </ArgonTypography>

          {/* Form Fields */}
          <Grid container spacing={3}>
            {/* Name */}
            <Grid item xs={12} md={6}>
              <ArgonBox mb={1}>
                <ArgonTypography
                  variant="button"
                  color="text"
                  fontWeight="medium"
                >
                  Name
                </ArgonTypography>
              </ArgonBox>
              <ArgonInput
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                type="text"
                placeholder="Enter your name"
                fullWidth
                sx={{
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                }}
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12} md={6}>
              <ArgonBox mb={1}>
                <ArgonTypography
                  variant="button"
                  color="text"
                  fontWeight="medium"
                >
                  Email Address
                </ArgonTypography>
              </ArgonBox>
              <ArgonInput
                 name="email"
                value={formData.email}
                onChange={handleChange}
                type="email"
                placeholder="jesse@example.com"
                fullWidth
                sx={{
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                }}
              />
            </Grid>
          </Grid>

          {/* Buttons */}
          <ArgonBox
            display="flex"
            justifyContent="center"
            gap={3}
            mt={5}
            flexWrap="wrap"
          >
            <ArgonButton
              variant="gradient"
              color="info"
               onClick={() => setConfirmUpdateOpen(true)}
              // onClick={handleUpdate}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: "10px",
                fontWeight: "bold",
                fontSize: "0.95rem",
                boxShadow: "0px 4px 12px rgba(0,123,255,0.2)",
              }}
            >
              Update Profile
            </ArgonButton>

            <ArgonButton
              variant="gradient"
              color="warning"
              onClick={handlePassword}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: "10px",
                fontWeight: "bold",
                fontSize: "0.95rem",
                boxShadow: "0px 4px 12px rgba(255,193,7,0.3)",
              }}
            >
              Change Password
            </ArgonButton>
          </ArgonBox>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Card>

      <Dialog
        open={confirmUpdateOpen}
        onClose={() => setConfirmUpdateOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <ArgonTypography variant="h6" fontWeight="bold" color="dark">
            Are you sure you want to update profile?
          </ArgonTypography>
        </DialogTitle>
        <DialogContent>
          <ArgonTypography variant="body2" color="text">
            Please confirm before updating your profile information.
          </ArgonTypography>
        </DialogContent>
        <DialogActions>
          <ArgonButton
            variant="gradient"
            color="secondary"
            onClick={() => setConfirmUpdateOpen(false)}
          >
            Cancel
          </ArgonButton>
          <ArgonButton variant="gradient" color="info" onClick={handleSaveUpdate}>
            Update
          </ArgonButton>
        </DialogActions>
      </Dialog>

   {/* Modal */}
      <Dialog open={password} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <ArgonTypography variant="h6" fontWeight="bold" color="dark">
            Change Password
          </ArgonTypography>
        </DialogTitle>

        <form>
          <DialogContent>
            <Grid container spacing={3}>
              {/* New Password */}
              <Grid item xs={12}>
                <ArgonBox mb={1}>
                  <ArgonTypography variant="button" color="text" fontWeight="medium">
                    New Password
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput
                  type="password"
                  placeholder="Enter new password"
                
                  fullWidth
                />
              </Grid>

              {/* Confirm Password */}
              <Grid item xs={12}>
                <ArgonBox mb={1}>
                  <ArgonTypography variant="button" color="text" fontWeight="medium">
                    Confirm Password
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput
                  type="password"
                  placeholder="Confirm password"
               
                  fullWidth
                />
              </Grid>
            </Grid>
          </DialogContent>

          {/* Footer Buttons */}
          <DialogActions>
            <ArgonButton variant="gradient" color="warning" onClick={handleClose}>
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="gradient"
              color="success"
              sx={{ fontWeight: "bold" }}
            >
              Save Changes
            </ArgonButton>
          </DialogActions>
        </form>
      </Dialog>

        {/* Modal */}
      {/* <Dialog open={update} onClose={handleCloseUpdate} maxWidth="sm" fullWidth>
        <DialogTitle>
          <ArgonTypography variant="h6" fontWeight="bold" color="dark">
            Update Profile
          </ArgonTypography>
        </DialogTitle>

        <form>
          <DialogContent>
            <Grid container spacing={3}>
             
              <Grid item xs={12}>
                <ArgonBox mb={1}>
                  <ArgonTypography variant="button" color="text" fontWeight="medium">
                    Enter Name
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput
                  type="text"
                  placeholder="Enter new name"
                
                  fullWidth
                />
              </Grid>

            
              <Grid item xs={12}>
                <ArgonBox mb={1}>
                  <ArgonTypography variant="button" color="text" fontWeight="medium">
                    Enter Email
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput
                  type="email"
                  placeholder="Enter new email"
               
                  fullWidth
                />
              </Grid>
            </Grid>
          </DialogContent>

        
          <DialogActions>
            <ArgonButton variant="gradient" color="warning" onClick={handleCloseUpdate}>
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="gradient"
              color="success"
              sx={{ fontWeight: "bold" }}
            >
              Save Changes
            </ArgonButton>
          </DialogActions>
        </form>
      </Dialog> */}

    </ArgonBox>
  );
}

export default Header;





{/* <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="App"
                  icon={
                    <i className="ni ni-app" style={{ marginTop: "6px", marginRight: "8px" }} />
                  }
                />
                <Tab
                  label="Message"
                  icon={
                    <i
                      className="ni ni-email-83"
                      style={{ marginTop: "6px", marginRight: "8px" }}
                    />
                  }
                />
                <Tab
                  label="Settings"
                  icon={
                    <i
                      className="ni ni-settings-gear-65"
                      style={{ marginTop: "6px", marginRight: "8px" }}
                    />
                  }
                />
              </Tabs>
            </AppBar>
          </Grid> */}
